import React from 'react';
import {getInsuranceProviderDisplayNameUK} from '../util/gearOrderUtil';

const UKInsuranceDetails = ({ insuranceInfo }) => {
    if (!insuranceInfo) {
        return <div>No insurance details available.</div>;
    }

    let providerDisplayName = getInsuranceProviderDisplayNameUK(insuranceInfo.insuranceProvider)
   

    return (
       
        <>
            <div className="separator-2"></div>
            <div className="row">
                <div className="col-sm-6 col-md-4">
                    <strong>Insurance Company:</strong> {providerDisplayName || 'N/A'}
                </div>
                <div className="col-sm-6 col-md-4">
                    <strong>Subscriber ID:</strong> {insuranceInfo.subscriberId || 'N/A'}
                </div>
                <div className="col-sm-6 col-md-4">
                    <strong>Pre-Authorization Code:</strong> {insuranceInfo.preAuthCode || 'N/A'}
                </div>
            </div>
            {insuranceInfo.insuranceProvider === 'other' && (
                <div className="row">
                    <div className="col-sm-6 col-md-4">
                        <strong>Other Insurance Company:</strong> {insuranceInfo.otherProvider || 'N/A'}
                    </div>
                </div>
            )}
        </>
    )
    
};

export default UKInsuranceDetails;